import { LineItem, ZeroStartingPrice } from 'types';

/**
 * Identifies the line items whose negotiation starting price is zero.
 *
 * Eligibility reads `negotiation_starting_price`; the baseline `price` column does not decide it.
 * The returned `price` is still the row's baseline, so a matched row can carry a non-zero one -
 * callers that count these rows are unaffected, callers that read the value should not treat it
 * as the zero that matched.
 *
 * @param lineItems - The line items to check for a zero negotiation_starting_price
 * @returns An array of zero starting prices
 */
export const updateZeroStartingPricesByLineItems = (
  lineItems: LineItem[] = [],
): ZeroStartingPrice[] => {
  if (!lineItems || !Array.isArray(lineItems)) {
    return [];
  }

  const lineItemsWithZeroStartingPrice = lineItems.filter(lineItem => {
    if (!lineItem) return false;

    const rawStartingPrice = lineItem.negotiation_starting_price;
    const startingPrice = typeof rawStartingPrice === 'string'
      ? parseFloat(rawStartingPrice)
      : Number(rawStartingPrice);

    return !Number.isNaN(startingPrice) && startingPrice === 0;
  });

  return lineItemsWithZeroStartingPrice.map(lineItem => ({
    id: lineItem.id,
    lotId: lineItem.lot_id,
    price: (lineItem.price ?? 0).toString()
  }));
};
